export type ResolvedDatabaseCommentIds = {
	contentId: string | undefined;
	referenceId: string | undefined;
};

export type ResolvedCommentHandler = (resolvedIds: ResolvedDatabaseCommentIds) => void;
export class DatabaseResolvedCommentsService {
	private reopenResolvedCommentCallback: ResolvedCommentHandler;

	constructor() {
		this.reopenResolvedCommentCallback = () => {};
	}

	dispose() {
		this.reopenResolvedCommentCallback = () => {};
	}

	/**
	 * This is called in databases to register the callback confluence FE
	 * will call after a resolved comment has been reopened
	 */
	registerOnReopenResolvedComment(callback: ResolvedCommentHandler): void {
		this.reopenResolvedCommentCallback = callback;
	}

	/**
	 * This will be called in confluence FE after we have successfully
	 * reopened a resolved comment. This allows databases to re-fetch and re-render
	 * the comment
	 */
	onReopenResolvedComment(commentIds: ResolvedDatabaseCommentIds) {
		this.reopenResolvedCommentCallback(commentIds);
	}
}
